import Layout from '@/components/Layout';
import HomePage from '@/pages/Home';

const App = () => (
  <Layout>
    <HomePage />
  </Layout>
);

export default App;
